export default function Wrapper({
    title,
    description,
    containerClass = "bg-gray-50 rounded-lg border border-gray-100",
    fieldsClass = "grid grid-cols-1 lg:grid-cols-2 lg:gap-10 gap-6 p-4",
    titleWrapperClass = "px-4 py-3 border-b border-gray-100",
    titleClass = "text-base font-semibold text-gray-700",
    descriptionClass = "text-xs text-gray-500",
    children,
}) {
    return (
        <div className={containerClass}>
            {title && (
                <div className={titleWrapperClass}>
                    <h3
                        className={`${titleClass} ${description ? "mb-1" : ""}`}
                    >
                        {title}
                    </h3>
                    {description && (
                        <p className={descriptionClass}>{description}</p>
                    )}
                </div>
            )}
            <div className={fieldsClass}>{children}</div>
        </div>
    );
}
